import React, { useRef, useState, useEffect } from 'react';
import { svg } from '../assets/svg/common.js'
import { sidebar_svg } from '../assets/svg/sidebar.js'
import { useDispatch, useSelector } from "react-redux";
import { DatePicker } from 'antd';
import moment from 'moment';
import { useLoading } from '../context/LoadingContext';
import { deleteEmails } from '../helper/emailHelper.js';

const { RangePicker } = DatePicker;
const FilterHeader = () => {
    const [isFilter, setIsFilter] = useState(false);
    const [isMore, setIsMore] = useState(false);
    const [filterData, setFilterData] = useState({
        from: '',
        to: '',
        subject: '',
        dateRange: [],
    });
    const dispatch = useDispatch();
    const refreshMessage = useSelector((state) => state.refreshMessage);
    const selectedMessages = useSelector((state) => state.selectedMessages);
    const isChecked = useSelector((state) => state.isChecked);
    const triggerFilter = useSelector((state) => state.trigger);
    const filterRef = useRef(null);
    const triggerfilterRef = useRef(null);
    const moreRef = useRef(null);
    const triggerMoreRef = useRef(null);
    const { showLoader, hideLoader } = useLoading();
    const pathName = window.location.pathname;

    useEffect(() => {

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFilterData({
            ...filterData,
            [name]: value,
        });
    };

    const handleClickOutside = (event) => {
        const datePickerElement = document.querySelector('.ant-picker-panel-container') ?? false;
        if (filterRef.current && !filterRef.current.contains(event.target) && triggerfilterRef.current && !triggerfilterRef.current.contains(event.target)) {
            if (datePickerElement && !datePickerElement.contains(event.target)) {
                setIsFilter(false);
            } else if (!datePickerElement) {
                setIsFilter(false);
            }
        }
        if (moreRef.current && !moreRef.current.contains(event.target) && triggerMoreRef.current && !triggerMoreRef.current.contains(event.target)) {
            setIsMore(false);
        }
    };

    const handleDateChange = (dates) => {
        setFilterData({
            ...filterData,
            dateRange: dates,
        });
    };

    const disabledDate = (current) => {
        return current && current > moment().startOf('day');
    };

    const handleSubmit = () => {
        dispatch({ type: "FILTER_OBJECT", payload: filterData, value: !triggerFilter });
        setIsFilter(false);
    };

    const deleteMessage = async () => {
        if (selectedMessages.length > 0) {
            const pageType = (pathName === '/home') ? 'inbox' : pathName.replace("/", "");
            showLoader();
            await deleteEmails(pageType, selectedMessages);
            dispatch({ type: "SELECTED_MESSAGES", payload: [] });
            dispatch({ type: "REFRESH_MESSAGE", payload: !refreshMessage });
            setIsMore(false);
            hideLoader();
        }
    }

    return (
        <>
            <div className="row d-flex justify-content-center align-items-center">
                <div className="col-lg-3 col-md-4 col-sm-6 col-8 d-flex justify-content-between align-items-center border-bottom pb-3 pt-3 border-end">
                    <div className='d-flex gap-2'>
                        <span><input type="checkbox" value={isChecked} onClick={() => {
                            dispatch({ type: "IS_CHECKED", payload: !isChecked });
                        }} /></span>
                        <span className='fw-semibold text-start'>Most Recent</span>
                        <span className='cursor-pointer'>{svg.down_arrow}</span>
                    </div>
                    <div className='d-flex gap-2'>
                        <span className='cursor-pointer' onClick={() => {
                            dispatch({ type: "REFRESH_MESSAGE", payload: !refreshMessage })
                        }}>{sidebar_svg.reload}</span>
                        <span className='cursor-pointer' ref={triggerfilterRef} onClick={() => {
                            setIsFilter(!isFilter);
                        }}>{svg.filter}</span>
                        <span className='cursor-pointer' ref={triggerMoreRef} onClick={() => {
                            setIsMore(!isMore);
                        }}>{svg.menu}</span>
                        {isMore &&
                            <div className='more-section' ref={moreRef}>
                                <div className="card">
                                    <div className="card-body">
                                        <div className='d-flex gap-3 align-items-center cursor-pointer' onClick={async (e) => {
                                            await deleteMessage();
                                        }}>
                                            <span>{svg.delete}</span>
                                            <span>Delete</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    {isFilter &&
                        <div className='filter-section' ref={filterRef}>
                            <div className="card">
                                <div className="card-body">
                                    <div className="border-bottom d-flex mt-2 gap-10">
                                        <span><b>From:</b> </span>
                                        <input className="reply-user-input compose" name='from' value={filterData.from}
                                            onChange={handleInputChange} />
                                    </div>
                                    <div className="border-bottom d-flex mt-4 gap-10">
                                        <span><b>To:</b> </span>
                                        <input className="reply-user-input compose" name='to' value={filterData.to}
                                            onChange={handleInputChange} />
                                    </div>
                                    <div className="border-bottom d-flex mt-4 gap-10">
                                        <span><b>Subject:</b> </span>
                                        <input className="reply-user-input compose" name='subject' value={filterData.subject}
                                            onChange={handleInputChange} />
                                    </div>
                                    <div className="d-flex mt-4 align-items-center gap-10">
                                        <span><b>Date within:</b> </span>
                                        <RangePicker
                                            className="custom-date-picker"
                                            placeholder={['Start Date', 'End Date']}
                                            disabledDate={disabledDate}
                                            value={filterData.dateRange}
                                            onChange={handleDateChange}
                                        />
                                    </div>
                                    <div className="d-flex mt-4 gap-3 justify-content-end align-items-center">
                                        <a className="cursor-pointer text-decoration-none gradient-text" onClick={() => {
                                            setFilterData({
                                                from: '',
                                                to: '',
                                                subject: '',
                                                dateRange: [],
                                            });
                                            dispatch({ type: "FILTER_OBJECT", payload: {}, value: !triggerFilter });
                                            setIsFilter(false);
                                        }
                                        }>Reset</a>
                                        <button className="linear-gradient-btn" onClick={handleSubmit}>Search</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                </div>
                <div className="col d-flex justify-content-start align-items-center">
                    {/* <span className='cursor-pointer'>{svg.left_arrow}</span> */}
                </div>
            </div>
        </>
    );
};


export default FilterHeader;
